<template>
    <div class="form-page">
        <my-form class="form-page" 
            v-model="form" 
            table 
            label-width="180px" 
            @cancle="cancleHandler" 
            :submit-url="`${getGetters('ageUrl')}/bidding/hzbSite/info.json`">
                <el-form-item 
                class="table-full-row"
                label="招标项目名称">
                    {{initialization.zbproname}}
                </el-form-item>


                <my-form-item-group title="开标室信息">
                    <el-form-item 
                    class="table-full-row"
                    prop="site_guid" 
                    :rules="newRule('选择开标室', 'required')"
                    label="选择开标室">
                        <my-select
                            v-model="form.site_guid"
                            :data="kblist"
                            :props="{value:'id',label:'name'}"
                            2way="name"
                            :name.sync="form.site_name">
                        </my-select>
                    </el-form-item>

                    <el-form-item label="开始时间"  
                        prop="starttime" 
                        :rules="newRule('开始时间', 'required')">
                            <el-date-picker
                                v-model="form.starttime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                :picker-options="datePickerOptions"
                                default-time="00:00:00">
                            </el-date-picker>
                    </el-form-item>

                    <el-form-item 
                        label="结束时间"  
                        prop="endtime" 
                        :rules="newRule('结束时间', 'required')">
                            <el-date-picker
                                v-model="form.endtime"
                                :disabled="!form.starttime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                :picker-options="pickerOptionsend"
                                default-time="00:00:00">
                            </el-date-picker>
                    </el-form-item>
                </my-form-item-group>

                <my-form-item-group title="评标室信息">
                    <el-form-item 
                    class="table-full-row"
                    prop="pb_site_guid" 
                    :rules="newRule('选择评标室', 'required')"
                    label="选择评标室">
                        <my-select
                            v-model="form.pb_site_guid"
                            :data="pblist"
                            :props="{value:'id',label:'name'}"
                            2way="name"
                            :name.sync="form.pb_site_name">
                        </my-select>
                    </el-form-item>

                    <el-form-item label="开始时间"  
                        prop="pb_starttime" 
                        :rules="newRule('开始时间', 'required')">
                            <el-date-picker
                                v-model="form.pb_starttime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                :picker-options="datePickerOptions"
                                default-time="00:00:00">
                            </el-date-picker>
                    </el-form-item>

                    <el-form-item 
                        label="结束时间"  
                        prop="pb_endtime" 
                        :rules="newRule('结束时间', 'required')">
                            <el-date-picker
                                v-model="form.pb_endtime"
                                :disabled="!form.pb_starttime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                :picker-options="pickerOptionsend"
                                default-time="00:00:00">
                            </el-date-picker>
                    </el-form-item>
                </my-form-item-group>

                <my-form-item-group title="其他信息">
                    <el-form-item 
                        label="选择标段"  
                        prop="bdcodes" 
                        class="table-full-row"
                        :rules="newRule('选择标段', 'required')">
                            <my-checkbox
                                model-str
                                str-spliter=","
                                v-model="form.bdcodes"
                                :data="initialization.zbbdList"
                                :props="{label:'bdname',value:'bdcode'}">
                            </my-checkbox>
                    </el-form-item>    

                    <el-form-item 
                        label="代理公司"  
                        prop="zbdl" 
                        class="table-full-row"
                        :rules="newRule('代理公司', 'required')">
                        <el-input v-model="form.zbdl"></el-input>
                    </el-form-item>    

                    <el-form-item 
                        label="联系人"  
                        prop="lxr" 
                        :rules="newRule('联系人', 'required')">
                        <el-input v-model="form.lxr"></el-input>
                    </el-form-item>       

                    <el-form-item 
                        label="联系电话"  
                        prop="lxrtel" 
                        :rules="newRule('联系电话', 'required', 'mobile')">
                        <el-input v-model="form.lxrtel"></el-input>
                    </el-form-item>        
                </my-form-item-group>
                <template slot="btn" slot-scope="scope">
                    
                    <el-button 
                    @click="saveHandler(9, scope.submitHandler)" 
                    type="primary" 
                    icon="el-icon-circle-check">
                        提交
                    </el-button>

                    <el-button 
                    @click="saveHandler(0, scope.submitHandler)" 
                    type="primary" 
                    icon="el-icon-circle-check">
                        保存
                    </el-button>

                    <el-button 
                    icon="el-icon-circle-close" 
                    @click="scope.cancleHandler">
                        取消
                    </el-button>
                </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
export default {
    mixins: [FORM_PAGE_MIXIN],
    data() {
        var that = this;
        return{
            form:{
                
            },   
            initialization:{},
            kblist:[
                { id:'1',name:'第一开标室'},
                { id:'2',name:'第二开标室'},
            ],
            pblist:[
                { id:'1',name:'第一评标室'},
                { id:'2',name:'第二评标室'},
            ],
            // 开始时间
            datePickerOptions: {
                disabledDate(time) {
                    var today = new Date().pattern('yyyy/MM/dd');
                    return time.getTime() < new Date(today).getTime();
                }
            },
            //结束时间
            pickerOptionsend: {
                disabledDate(time) { //结束时间的禁用
                    var newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(that.form.starttime)
                    return time.getTime() <new Date(newDate[0]+ ' 00:00').getTime();
                }
            },     
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        saveHandler(type, cb){
            this.form.shbj = type;
            // 循环获取标段名称
            var arr = this.form.bdcodes.split(',');
            var list = [];
            for(var i=0;i<arr.length;i++){
                this.initialization.zbbdList.forEach(function(item){
                    if(arr[i]==item.bdcode){
                        list.push(item.bdname);
                    }
                })

            }
            this.form.by3 = list.toString();
            cb && cb();
        }
    },
    created() {
        var that = this   
        
        that.jspInit(`${that.getGetters('ageUrl')}/bidding/hzbSite/init.json`, {
            zbprocode:that.getQuery('zbprocode'),
            guid:that.getQuery('guid'),
        }, data => {
            if(that.getQuery('guid')){
                that.form = data.VSite;
            }
            that.form.zbprocode = that.getQuery('zbprocode');
            that.form.guid = that.getQuery('guid');
            that.initialization = data;
        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
